// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"4351acb8","340":"b3b0ce25","453":"8ff3277a","562":"bd6438a9","576":"5af44345","809":"94d76235","875":"4fdaf041","963":"6b99d386"}[chunkId] + ".chunk.js";
};